export default "__VITE_ASSET__iw0p4WoZ__"